import request from 'utils/request'
import studentRequest from 'utils/studentRequest'
import instRequest from 'utils/instRequest'
import adminRequest from 'utils/adminRequest'
import rolesApi from 'utils/corporateRequest'
import authRequest from 'utils/authRequest'

const initializeApp = token => {
  request.defaults.headers.common['Authorization'] = token
  studentRequest.defaults.headers.common['Authorization'] = token
  instRequest.defaults.headers.common['Authorization'] = token
  adminRequest.defaults.headers.common['Authorization'] = token
  rolesApi.defaults.headers.common['Authorization'] = token
  authRequest.defaults.headers.common['Authorization'] = token
}

export default initializeApp
